// src/pages/Register.js
import React, { useState } from 'react';
// import './Register.css';

function Register() {
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        email: '',
        fullname: '',
    });
    const [errors, setErrors] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors([]);
        setSuccessMessage('');
        try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
        });
        const data = await response.json();
        if (response.ok) {
            setSuccessMessage(data.message);
            setFormData({ username: '', password: '', email: '', fullname: '' });
        } else {
            setErrors(data.errors || [{ msg: data.error }]);
        }
        } catch (error) {
            console.error('Error during registration:', error);
            setErrors([{ msg: 'An error occurred during registration.' }]);
        }
    };

  return (
    <div className="page-content">
        <form onSubmit={handleSubmit} className="register-form">
            <h2>User Registration</h2>
            {successMessage && <p className="success">{successMessage}</p>}
            {errors.length > 0 && (
            <ul className="error-list">
                {errors.map((error, index) => (
                <li key={index} className="error">
                    {error.msg}
                </li>
                ))}
            </ul>
            )}
            <div>
            <label htmlFor="username">Username:</label>
            <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                className="input-field"
            />
            </div>
            <div>
            <label htmlFor="fullname">Full Name:</label>
            <input
                type="text"
                id="fullname"
                name="fullname"
                value={formData.fullname}
                onChange={handleChange}
                required
                className="input-field"
            />
            </div>
            <div>
            <label htmlFor="email">Email:</label>
            <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="input-field"
            />
            </div>
            <div>
            <label htmlFor="password">Password:</label>
            <input
                type="password"
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="input-field"
            />
            </div>
            <button type="submit" className="button button-m">
            Register
            </button>
        </form>
    </div>
  );
}

export default Register;
